<template>
    <div class="tonglan">
    <div class="xwlb">
        <div id="lbl" class="lbl">
            <div class="dbti" id="conent">
                <h1 style="text-align:center;height:40px;padding-top:25px">{{article.title}}</h1>
                    <h2 style="height:30px;">作者：{{article.publishName}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;更新时间：{{article.publishTime}}</h2>
                    <br />
                    <p id="con" v-html="article.content"></p>
                <br />
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { getArticle } from '../api/article'
export default {
  name: 'ArticleDetail',
  data () {
    return {
      article: {}
    }
  },
  mounted () {
    console.log(this.$route.query.id)
    getArticle({ id: this.$route.query.id }).then(response => {
      this.article = response.data
    })
  }
}
</script>
